import React from 'react';
import { APACHE_OSSIE_HUB } from '../../../content/enterpriseMessaging';

const pillars = [
  {
    title: 'Our approach',
    body: 'We convert dashboards, reports, pipelines, and domain knowledge into semantic layers and reusable decision context built for Snowflake Enterprise AI.',
  },
  {
    title: 'Define once, consume everywhere',
    body: 'Metrics and business concepts are modeled once, then reused across Power BI, Tableau, QuickSight, Streamlit, embedded apps, and conversational analytics experiences.',
  },
  {
    title: 'Unified platforms, not more silos',
    body:
      'The future of Enterprise AI requires collapsing silos across transactional systems, analytics platforms, BI tools, documents, and applications. ' +
      'MyOrgLab builds on foundational platforms such as Snowflake, Postgres, Power BI, Tableau, QuickSight, Streamlit, React, and Java, ' +
      'connecting them through semantic models, governed context, and intelligent applications.',
  },
  {
    title: 'Open semantic alignment',
    body:
      `We align to ${APACHE_OSSIE_HUB.eyebrow} so governed business meaning can move across AI agents, BI tools, and enterprise applications. Apache Ossie is the Incubator specification, not a MyOrgLab product.`,
  },
];

const CompanyApproach = () => {
  return (
    <section className="section">
      <div className="container-x min-w-0">
        <div className="max-w-3xl min-w-0">
          <p className="eyebrow">How we work</p>
          <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
            Semantic foundations, delivered with enterprise rigor.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-600">
            We design governed business meaning once, then make it usable across analytics, applications,
            and AI, so teams stop redefining the same metrics in every tool. That work still sits on sound data infrastructure: Terraform, CI/CD, dbt, agile delivery, Azure DevOps, GitHub Actions, and Airflow.
          </p>
          <p className="mt-4">
            <a href="/delivery" className="inline-flex min-h-[24px] items-center text-brand-600 font-semibold hover:text-brand-700 underline-offset-2 hover:underline">
              See how we deliver with Agile and Azure DevOps →
            </a>
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2">
          {pillars.map((pillar) => (
            <div key={pillar.title} className="card card-hover min-w-0 p-7">
              <h3 className="font-display text-lg font-semibold text-ink-900">{pillar.title}</h3>
              <p className="mt-3 text-ink-600 leading-7">{pillar.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyApproach;
